import { useExtendWithSubnetworks } from "@l2r-front/l2r-networks"

import { API_MODULE_ROADWORK } from "../../../../common/constants/appRoad"
import { useRoadworksQuery } from "../../../../common/hooks/queries/useRoadworksQuery"

import { roadworksQueryKeys } from "./queryKeys"

export function useRoadworksStatLengthUnique(
    queryParameters,
    config = {},
) {

    const url = "roadworks/stats/length_unique/"
    const parameters = useExtendWithSubnetworks(queryParameters, API_MODULE_ROADWORK)
    const queryKey = roadworksQueryKeys["stat_length_unique"](parameters)

    return useRoadworksQuery(
        url,
        queryKey,
        parameters,
        { ...config },
    )
}